// extracted by mini-css-extract-plugin
export default {"container":"Processing_container__5grCE","text":"Processing_text__uSOMg","loader":"Processing_loader__9+YEs","btnWrapper":"Processing_btnWrapper__SlZId"};